import { NgModule } from "@angular/core";
import { SopoToastComponent } from "./components/toast/sopo-toast.component";

@NgModule({
	imports: [SopoToastComponent],
	declarations: [],
})
export class SopoToastModule {}
